import { useEffect, useState } from "react";
import { useLocalStorage } from "usehooks-ts";

import { useDismissWelcomeMessageMutation } from "../services/api/organisationApi/organisation";

import { useGetSelectedOrganisation } from "./useGetSelectedOrganisation";
import { useGetSubscriptionMetadata } from "./useGetSubscription";

export function useWelcomeMessage(): {
  showWelcomeMessage: boolean;
  dismissWelcomeMessage: () => void;
  } {
  const currentOrg = useGetSelectedOrganisation();
  const subMetadata = useGetSubscriptionMetadata();
  const [ dismissWelcomeMessage, { isLoading } ] = useDismissWelcomeMessageMutation();
  const [showWelcomeState, setShowWelcomeState] = useState(!!currentOrg);
  const [dismissedCalled, setDismissedCalled] = useState(false);
  const [hasDismissed, setHasDismissed] = useLocalStorage(`welcomeMessageDismissed-${currentOrg?.id || `-`}`, false);
  // Also put in local storage, in case an error that forces modal

  function onDismiss() {
    setShowWelcomeState(false);
    setHasDismissed(true);
    if (!currentOrg || currentOrg.welcomeMessageDismissed) {
      return;
    }

    dismissWelcomeMessage(currentOrg.id);
  }

  useEffect(() => {
    if (hasDismissed) {
      setShowWelcomeState(false);

      if (currentOrg && currentOrg.connected && !currentOrg.welcomeMessageDismissed && !dismissedCalled) {
        // Dimissed locally but not on server, so we need to dismiss it
        setDismissedCalled(true);
        dismissWelcomeMessage(currentOrg.id);
      }

      return;
    }

    if (
      !currentOrg ||
      currentOrg.welcomeMessageDismissed ||
      isLoading ||
      !currentOrg.connected
    ) {
      if (showWelcomeState) {
        setShowWelcomeState(false);
      }

      return;
    }

    if (!currentOrg.onboarding?.status || ![`COMPLETED`, `SKIPPED`].includes(currentOrg.onboarding.status)) {
      if (showWelcomeState) {
        setShowWelcomeState(false);
      }

      return;
    }

    // If they have any type of stripe sub, dont show
    if (subMetadata?.subscriptionMetadata?.status) {
      if (showWelcomeState) {
        setShowWelcomeState(false);
      }

      return;
    }

    if (!showWelcomeState && currentOrg) {
      console.log(`Showing welcome message for org`, currentOrg);
      setShowWelcomeState(true);
    }
  }, [ currentOrg, isLoading, showWelcomeState, subMetadata, dismissWelcomeMessage ]);

  return {
    showWelcomeMessage: showWelcomeState,
    dismissWelcomeMessage: onDismiss,
  };
}
